import Router from 'vue-router'
import Help from '@/view/pomelo/app/Help'
import ContentBack from '@/view/pomelo/app/ContentBack'
import BackList from '@/view/pomelo/app/BackList'
import CleanNet from '@/view/pomelo/app/CleanNet'
import FraudBar from '@/view/pomelo/app/FraudBar'
import HowPlay from '@/view/pomelo/app/HowPlay'
import User from '@/view/pomelo/app/agreement/User'
import Privacy from '@/view/pomelo/app/agreement/Privacy'
import Recharge from '@/view/pomelo/app/agreement/Recharge'
import Vip from '@/view/pomelo/app/agreement/Vip'
import Cash from '@/view/pomelo/app/Cash'
import Task from '@/view/pomelo/app/task/index'
import Score from '@/view/pomelo/app/score/index'
import Store from '@/view/pomelo/app/store/index'
import NewStore from '@/view/pomelo/app/newStore/index'
import Invite from '@/view/pomelo/app/invite/index'
import Share from '@/view/pomelo/app/share/index'
import Valentine from '@/view/pomelo/app/valentine/index'
import MidAutumn from '@/view/pomelo/app/midAutumn/index'
import National from '@/view/pomelo/app/national/index'
import HappyNewYear from '@/view/pomelo/app/newYear/index'
import NewYearList from '@/view/pomelo/app/newYear/list'
import Test from '@/view/pomelo/app/test/index'
import Labor from '@/view/pomelo/app/labor/index'
import LaborList from '@/view/pomelo/app/labor/list'
export default new Router({
  mode: 'history',
  routes: [
    //帮助中心主菜单
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        title: '帮助中心'
      }
    },
    //帮助中心列表菜单
    {
      path: '/backList',
      name: 'BackList',
      component: BackList,
    },
    //帮助中心最里层
    {
      path: '/contentBack',
      name: 'ContentBack',
      component: ContentBack,
    },
    //净网公约
    {
      path: '/cleanNet',
      name: 'CleanNet',
      component: CleanNet,
      meta: {
        title: '详情',
        keepAlive: true
      }
    },
    //诈骗指南
    {
      path: '/fraudBar',
      name: 'FraudBar',
      component: FraudBar,
      meta: {
        title: '详情',
        keepAlive: true
      }
    },
    //教你玩转音柚
    {
      path: '/howPlay',
      name: 'HowPlay',
      component: HowPlay,
      meta: {
        title: '详情',
        keepAlive: true
      }
    },
    //用户协议
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: '用户协议'
      },
    },
    //隐私协议
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: '隐私协议'
      },
    },
    //充值协议
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge,
      meta: {
        title: '充值协议'
      },
    },
    //充值协议
    {
      path: '/cash',
      name: 'Cash',
      component: Cash,
      meta: {
        title: '兑换说明'
      },
    },
    //我的金币
    {
      path: '/score',
      name: 'score',
      component: Score,
      meta: {
        title: '我的金币'
      },
    },
    //任务中心
    {
      path: '/task',
      name: 'task',
      component: Task,
      meta: {
        title: '任务中心'
      },
    },
    //好评
    {
      path: '/store',
      name: 'store',
      component: Store,
      meta: {
        title: '详情'
      },
    },
    //好评
    {
      path: '/newStore',
      name: 'newStore',
      component: NewStore,
      meta: {
        title: '详情'
      },
    },
    //活动
    // {
    //   path: '/activity',
    //   name: 'activity',
    //   component: Activity,
    //   meta: {
    //     title: '活动详情'
    //   },
    // },
    //邀请奖励
    {
      path: '/invite',
      name: 'invite',
      component: Invite,
      meta: {
        title: '邀请奖励'
      },
    },
    //分享
    {
      path: '/share',
      name: 'share',
      component: Share,
      meta: {
        title: '分享'
      },
    },
    //情人节
    {
      path: '/valentine',
      name: 'valentine',
      component: Valentine,
      meta: {
        title: '活动详情'
      },
    },
    //中秋节
    {
      path: '/midAutumn',
      name: 'midAutumn',
      component: MidAutumn,
      meta: {
        title: '活动详情'
      },
    },   //国庆节
    {
      path: '/national',
      name: 'national',
      component: National,
      meta: {
        title: '活动详情'
      },
    },
    //新年
    {
      path: '/happyNewYear',
      name: 'happyNewYear',
      component: HappyNewYear,
      meta: {
        title: '活动详情'
      },
    },
    //新年榜单
    {
      path: '/newYear/list',
      name: 'NewYearList',
      component: NewYearList,
      meta: {
        title: '详情'
      },
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      meta: {
        title: '测试'
      },
    },

    //五一活动
    {
      path: '/labor',
      name: 'labor',
      component: Labor,
      meta: {
        title: '活动详情'
      },
    },
    //五一榜单
    {
      path: '/labor/list',
      name: 'LaborList',
      component: LaborList,
      meta: {
        title: '详情'
      },
    },
    {
      path: '/vip',
      name: 'Vip',
      component: Vip,
      meta: {
        title: '会员协议'
      },
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js